import { render, staticRenderFns } from "./Jingdong.vue?vue&type=template&id=6bb7b1b8&scoped=true"
import script from "./Jingdong.vue?vue&type=script&lang=js"
export * from "./Jingdong.vue?vue&type=script&lang=js"
import style0 from "./Jingdong.vue?vue&type=style&index=0&id=6bb7b1b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb7b1b8",
  null
  
)

export default component.exports